import { datadogLogs } from '@datadog/browser-logs';

import { APP_VERSION, DATADOG_CLIENT_TOKEN, DATADOG_ENABLED, DATADOG_ENVIRONMENT, DATADOG_SERVICE, DATADOG_VERSION, VERCEL_DEPLOYMENT_ID } from 'state_management/env_constants';

import { getIsDocumentDefined } from './getIsDocumentDefined';

let isInitialized = false;
let isDatadogLoggingEnabled = false;

export const isDatadogEnabled = () => isDatadogLoggingEnabled;

export const toggleDatadogLogging = (enabled: boolean) => {
  isDatadogLoggingEnabled = enabled;
};

export const initDatadogLogs = () => {
  if (
    DATADOG_ENABLED &&
    !isInitialized &&
    // datadogLogs will attempt to access `document` and fail if `document`
    //  does not exist
    getIsDocumentDefined()
  ) {
    isInitialized = true;

    datadogLogs.init({
      beforeSend: () => isDatadogLoggingEnabled,
      clientToken: DATADOG_CLIENT_TOKEN,
      env: DATADOG_ENVIRONMENT,
      service: DATADOG_SERVICE,
      sessionSampleRate: 100,
      site: 'datadoghq.com',
      version: DATADOG_VERSION
    });
    if (APP_VERSION) datadogLogs.setGlobalContextProperty('app_version', APP_VERSION);
    if (VERCEL_DEPLOYMENT_ID) datadogLogs.setGlobalContextProperty('vercel_deployment_id', VERCEL_DEPLOYMENT_ID);

    logger.debug('datadogLogs initialized');
  }
};
